import React from 'react';
import PageHero from '../components/PageHero';
import CtaBand from '../components/CtaBand';
import SOLUTIONS from '../data/solutions';

export default function Solutions() {
  return (
    <>
      <PageHero
        modifier="solutions"
        kicker="Transformation Solutions"
        title="Solutions"
        desc="Business-outcome focused solutions for SAP integration, omnichannel retail, manufacturing analytics and ERP modernization."
      />
      <section className="section section-soft">
        <div className="container grid grid-2 animate-cards">
          {SOLUTIONS.map((s, i) => (
            <div className="card card--solution" key={i}>
              <div className="card-tag">{s.tag}</div>
              <div className="icon-circle">{s.icon}</div>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
              <div className="benefit-pills">
                {s.benefits.map((b, j) => <span className="benefit-pill" key={j}>{b}</span>)}
              </div>
            </div>
          ))}
        </div>
      </section>
      <CtaBand
        heading="Let's Build the Right Solution Together"
        sub="Talk to us about your transformation goals."
        linkTo="/contact"
        linkLabel="Get Started"
      />
    </>
  );
}
